import React from 'react';
import { Link } from 'react-router';
import { Sparkline } from './charts';
import s from '../pages/Home.module.css';

/**
 * Home's KPI tile — the label, the big number, the line under it (a delta: `tone` up / down) and a filled sparkline
 * with a hover tooltip. One component for the All Home and a department's Home (Lj, Oct 11: the All Home is the bar).
 * `to` = where a click goes (a route), or `onClick`.
 */
export default function Kpi({ label, value, sub, tone, points, format, color = 'var(--c-accent)', to, onClick }) {
  const body = (
    <>
      <div className={s.kpiLabel}>{label}</div>
      <div className={s.kpiValue}>{value}</div>
      <div className={s.kpiSub} data-tone={tone || undefined}>{sub}</div>
      <div className={s.kpiSpark}><Sparkline points={points} format={format} color={color} height={40} /></div>
    </>
  );
  if (to) return <Link to={to} className={s.kpi}>{body}</Link>;
  return <button type="button" className={s.kpi} style={{ textAlign: 'left' }} onClick={onClick}>{body}</button>;
}
